import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';
import { tableSettingsProps, useTableSettings } from 'src/core/tables/useTableSettings';
import { useSalesShippingMethods } from 'src/pages/settings/settingsRequests';

export const useSalesShippingMethodsTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const { rows, status, loading } = useSalesShippingMethods();
  const columns: GridColDef[] = useMemo(() => [
    { field: 'ShippingMethodId', headerName: 'Shipping Method Id' },
    { field: 'ShippingMethodName', headerName: 'Shipping Method Name', flex: 1 },
    { field: 'ShortName', headerName: 'Short Name' },
    { field: 'OriginalOrderModuleShippingMethodId', headerName: 'Original Order Module ShippingMethod Id' },
    { field: 'LogisticsPartnerServiceId', headerName: 'Logistics Partner Service Id' },
    { field: 'LogisticsPartnerService', headerName: 'Logistics Partner Service', flex: 1 },
    { field: 'ClientEnabled', headerName: 'Client Enabled' },
  ], []);
  const tableSettings = useTableSettings({ tableName: 'ShippingMethodsTable', idPath: ['ShippingMethodId'], columns, rows, status });
  tableSettings.loading = loading;
  return [columns, tableSettings];
};
